import { AppSelectabilityStore } from '../../store/AppSelectabilityStore/AppSelectabilityStore';

export interface UseAppSelectabilityHook {
  appIsUnselectable: boolean;
  setAppIsUnselectable: (value: boolean) => void;
}

/**
 * Read and write the shared "app is unselectable" flag. Components that initiate a drag
 * call `setAppIsUnselectable(true)` on pointer-down and `setAppIsUnselectable(false)` when
 * the drag ends.
 */
export const useAppSelectability = (): UseAppSelectabilityHook => {
  const appIsUnselectable = AppSelectabilityStore.use(state => state.appIsUnselectable);
  return { appIsUnselectable, setAppIsUnselectable: AppSelectabilityStore.setUnselectable };
};
